import BigNumber from 'bignumber.js'
import { ZERO } from 'constants/number'
import { avgAPY } from './calculateAPY'

interface SupplyChangeProps {
  supply?: BigNumber //usd
  change?: BigNumber
  netAPY?: BigNumber
  supplyAPY?: BigNumber
}

type Supply = BigNumber | undefined
type NetAPY = BigNumber | undefined

export const handleSupplyChange = ({
  supply = ZERO, // usd
  change = ZERO, // usd
  netAPY = ZERO,
  supplyAPY = ZERO,
}: SupplyChangeProps): [Supply, NetAPY] => {
  if (change.eq(ZERO)) return [undefined, undefined]

  const newSupply = supply.plus(change)
  const newNetAPY = avgAPY([
    { amount: supply, APY: netAPY },
    { amount: change, APY: supplyAPY },
  ])
  if (newNetAPY.eq(netAPY)) return [newSupply, undefined]
  return [newSupply, newNetAPY]
}
